import HelmetProvider from './HelmetProvider'
import QueryProvider from './QueryProvider'
import RecoilProvider from './RecoilProvider'
import RouterProvider from './RouterProvider'

const AppProviders = ({ children }) => {
  return (
    <RecoilProvider>
      <RouterProvider>
        <HelmetProvider>
          <QueryProvider>{children}</QueryProvider>
        </HelmetProvider>
      </RouterProvider>
    </RecoilProvider>
  )
}

export default AppProviders
